export default __webpack_public_path__ + "static/media/img-23-bruxo.e5ba0074.jpg";